module.exports = __webpack_public_path__ + "img/calli-great.cd817ea8.png";